import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    heading: 'heading-xl mb-6 block',
    buttons: 'flex gap-3',
    button: 'w-full'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
